export default {
  CASE_EVENTS: {
    SHOW_ALL_EVENTS: 'Show all events',
    SHOW_LESS_EVENTS: 'Show less events',
    PAYMENTS_OF_EVENT: 'Payments related to the event:',
    NOTIFICATION_SENT: '{{channel}} sent:',
    NOTIFICATION_CHANNEL: {
      Email: 'Email',
      SMS: 'SMS',
      FinanceEmail: 'Finance email',
    },
    ATTACHMENT: 'Attachment:',
    ATTACHMENTS: 'Attachments:',
    MESSAGE_OF_EVENT: 'Message related to the event:',
    EXTERNAL_ID_OF_EVENT: 'External ID:',
    BAILIFF_CONTACT: 'Bailiff contact',
    EXTERNAL_ID_TYPE: {
      ENFORCEMENT: 'Enforcement case number',
      BAILIFF: 'Bailiff identifier',
      OFP: 'Order for Payment case number',
    },
    OK: 'OK',
    ATTACH_MOKK_TO_LOG: 'Link MOKK to this event',
    REMOVE_MOKK_FROM_LOG: 'Remove MOKK from this event',
    NOTIFICATION_PREVIEW: {
      NO_PREVIEW: 'Preview is not available for this notification.',
      RECIPIENT: 'Recipient:',
      RECIPIENTS: 'Recipients:',
      CLOSE: 'Close',
    },
    ERROR_MESSAGES: {
      UNKNOWN_ERROR_WHILE_LOADING_EVENTS: 'Error while loading the events! Please try again.',
      ATTACH_MOKK_TO_LOG_FAILED: 'Could not link the MOKK to this event.',
      DETACH_MOKK_FROM_LOG_FAILED: 'Could not remove the MOKK from this event.',
    }
  },
};